"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneField = void 0;
var React = _interopRequireWildcard(require("react"));
var _MaskedInput = require("../MaskedInput");
var styles = _interopRequireWildcard(require("../InputField/styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PhoneField = exports.PhoneField = /*#__PURE__*/React.forwardRef(function PhoneField(props, ref) {
  const {
    name,
    placeholder,
    invalid,
    value,
    onValueChange,
    onKeyDown,
    onFocus,
    onBlur,
    errorMessage,
    autoFocus,
    disabled,
    autoComplete,
    inputRef
  } = props;
  const handleAccept = React.useCallback(value => {
    if (!onValueChange) {
      return;
    }
    onValueChange(value);
  }, [onValueChange]);
  const handlePrepare = React.useCallback((appended, masked) => {
    if (appended === '8' && masked.value === '') {
      return '';
    }
    return appended;
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: styles['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['input-group']
  }, /*#__PURE__*/React.createElement(_MaskedInput.MaskedInput, {
    inputRef: inputRef,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    placeholder: placeholder,
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    onBlur: onBlur,
    prepare: handlePrepare,
    invalid: invalid,
    disabled: disabled,
    value: value,
    name: name,
    type: "tel",
    size: "M",
    mask: "{+7} (000) 000-00-00",
    onAccept: handleAccept
  })), errorMessage && /*#__PURE__*/React.createElement("span", {
    className: styles['error-message']
  }, errorMessage));
});
PhoneField.displayName = 'PhoneField';